var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 16H16C13.8783 16 11.8434 16.8429 10.3431 18.3431C8.84285 19.8434 8 21.8783 8 24V80C8 82.1217 8.84285 84.1566 10.3431 85.6569C11.8434 87.1571 13.8783 88 16 88H72C74.1217 88 76.1566 87.1571 77.6569 85.6569C79.1571 84.1566 80 82.1217 80 80V52",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9.99993C75.5913 8.40863 77.7496 7.51465 80 7.51465C82.2504 7.51465 84.4087 8.40863 86 9.99993C87.5913 11.5912 88.4853 13.7495 88.4853 15.9999C88.4853 18.2504 87.5913 20.4086 86 21.9999L48 59.9999L32 63.9999L36 47.9999L74 9.99993Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEdit;